import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const CONTENTS_RULE_EDITOR_CLASS_NAME = 'ContentsRuleEditor';
export const CONTENTS_RULE_EDITOR_CLASS_SLOTS = ['root'] as const;

export type ContentsRuleEditorClassSlot =
	(typeof CONTENTS_RULE_EDITOR_CLASS_SLOTS)[number];

export interface ContentsRuleEditorClasses {
	root: string;
}

export type ContentsRuleEditorClassKey = keyof ContentsRuleEditorClasses;

export const getContentsRuleEditorUtilityClass = (slot: string) =>
	generateUtilityClass(CONTENTS_RULE_EDITOR_CLASS_NAME, slot);

export const contentsRuleEditorClasses: ContentsRuleEditorClasses =
	generateUtilityClasses(CONTENTS_RULE_EDITOR_CLASS_NAME, ['root']);

export default contentsRuleEditorClasses;
